import { fromJS } from 'immutable';
import { SET_PENDING_TREATEMENT_CLAIMS } from 'containers/ManagerPendingTreatementClaims/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

export interface ManagerPendingTreatementClaimsAction {
  type: string;
  payload?: any;
}

const initialState: any = fromJS({
  pendingClaims: [],
  count: null,
});

const ManagerPendingTreatementClaimsReducer = (
  state = initialState,
  action: ManagerPendingTreatementClaimsAction,
) => {
  switch (action.type) {
    case SET_PENDING_TREATEMENT_CLAIMS:
      return state
        .set('pendingClaims', fromJS(action.payload?.pendingNotifications))
        .set('count', fromJS(action.payload?.count));
    case RESET_STORE:
      return initialState;

    default:
      return state;
  }
};

export default ManagerPendingTreatementClaimsReducer;
